/**
 * Returns whether the browser is currently offline.
 * Falls back to true-is-online when the property is unavailable.
 *
 * @returns {boolean} true when offline
 */
export function isOffline() {
  return typeof navigator !== 'undefined' && navigator.onLine === false
}

/**
 * Subscribes to online/offline transitions.
 * Returns an unsubscribe function.
 *
 * @param {Function} callback receives true (online) or false (offline)
 * @returns {Function} unsubscribe function
 */
export function onConnectivityChange(callback) {
  const handleOnline = () => callback(true)
  const handleOffline = () => callback(false)

  window.addEventListener('online', handleOnline)
  window.addEventListener('offline', handleOffline)

  return () => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
  }
}
